import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BsCursorFill } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { FaGithub } from "react-icons/fa";
import { PiReadCvLogoBold } from "react-icons/pi";
import { FaDribbble } from "react-icons/fa";
import { BsFillLayersFill } from "react-icons/bs";
import { FaSquareUpwork } from "react-icons/fa6";
import { MousePointer2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const getRandomValue = (range) => Math.random() * range;

const getRandomTranslation = () => ({
  x: getRandomValue(100) - getRandomValue(80),
  y: getRandomValue(100) - getRandomValue(80),
  z: getRandomValue(100) - getRandomValue(80),
});


export default function Socials() {
  const [cursorTranslation, setCursorTranslation] = useState(getRandomTranslation());

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setCursorTranslation(getRandomTranslation());
    }, 1500); // Set an interval for unaivan

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <div className='md:mb-2 pb-16 z-[999]'>
      <div className=' mx-auto'>
        <div className='relative'>
          <section className='flex flex-col gap-12 mb-0'>
            <div className='col-span-4'>
                {/* <p className='font-normal text-gray-500 text-xl mb-4'>Got projects in mind?</p> */}
                <h1 className='xl:text-2xl text-xl font-bold leading-none'>Let's Connect Digitally </h1>
                <div className='flex items-center space-x-2 mt-4'>
                    <p className='text-zinc-600 text-sm'>Open to new freelance gigs</p>
                    <span className="relative flex h-3 w-3">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-300 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-green-400"></span>
                    </span>
                </div>
                <div className='flex items-center space-x-2'>
                    <p className='text-zinc-400 text-sm font-light'>Let’s make it happen!</p>
                </div>
            </div>
            <div className='flex flex-row flex-wrap gap-2'>
                <a target='_blank' href='https://www.linkedin.com/in/dinivan-nendra-gunawan/' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:-rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-blue-100 w-fit text-blue-500'><FaLinkedin /> Linkedin</a>
                {/* <a target='_blank' href='https://twitter.com/dinivannendra' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-sky-100 w-fit text-sky-500'><FaTwitter /> Twitter</a> */}
                <a href='mailto:dinivannendragunawan@gmail.com' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:-rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-rose-100 w-fit text-rose-500'><BiLogoGmail /> Mail</a>
                <a target='_blank' href='https://dribbble.com/unaivan' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-pink-100 w-fit text-pink-500'><FaDribbble /> Dribbble</a>
                <a target='_blank' href='https://github.com/unaivan22' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:-rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-stone-200 w-fit text-stone-500'><FaGithub /> Github</a>
                <a target='_blank' href='https://www.upwork.com/freelancers/~01d64cc952bed453f1' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-lime-200 w-fit text-lime-500'><FaSquareUpwork /> Upwork</a>
                <a target='_blank' href='https://layers.to/dinivannendra' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:-rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-purple-200 w-fit text-purple-500'><BsFillLayersFill /> Layers</a>
                {/* <a target='_blank' href='https://read.cv/dinivannendra' className='text-[1rem] md:text-xl font-bold hover:underline opacity-90 hover:scale-[1.2] transition ease-in-out delay-150 hover:-rotate-[12deg] hover:opacity-100 hover:z-[9999999] flex items-center gap-x-2 px-4 py-2 rounded-full bg-zinc-200 w-fit text-zinc-500'><PiReadCvLogoBold /> Read CV</a> */}
            </div>
                
          </section>
          <motion.div
              className='absolute md:bottom-[2vh] bottom-[16vh] md:right-[12vw] right-[30vw]'
              animate={{
                x: cursorTranslation.x,
                y: cursorTranslation.y,
                z: cursorTranslation.z,
              }}
              transition={{
                type: 'spring',
                stiffness: 50,
              }}
            >
            <div className='flex gap-x-1'>
              <MousePointer2 fill className='h-6 w-6 z-50' />
              {/* <div className='mt-6 -ml-2 py-1 px-2 bg-green-600 rounded-bl-xl rounded-br-xl rounded-tr-xl px-6 py-2 flex items-center gap-x-2 w-fit'>
                <p className='text-white text-[1.2rem]'>Hire me</p>
              </div> */}
              <Button className='rounded-full'>Open To Work</Button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}